import { HTML_ERRORS } from '@commoncore/constants/htmlErrors';
import { COMMON_ERROR } from '@core/constants/Constants';
import { ExceptionHandler } from '@core/exception/ExceptionHandler';
import { LOGIN_ERROR } from '../constants/LoginExceptionMessage';


export class LoginExceptions extends ExceptionHandler {
    public errorMessage = "";
    public universalService:any
    constructor(globalService) {
        super();
        this.universalService=globalService.getUniversalServiceRef();

    }

    //write specific error handling for login here
    async handleLoginError(screen, response) {
        this.universalService.showLoader= false;
        
        if(this.universalService.browserDetails.browser.name == "Safari") {
            var res = await this.universalService.checkInternetConnection();
            if(res) {
                this.universalService.connectionStatus = true;
            } else {
                this.universalService.connectionStatus = false;
            }
        }

        if(!this.universalService.connectionStatus){
			this.errorMessage = HTML_ERRORS["NETWORK_CONNECTION_ERR"];	
			return;
		}
        // show server error msg in following cases
        if(response.status == 450 || response.error.code == "SCLN0192" || response.error.code == "SCLN0193" || response.error.code == "SCLN0194" || response.error.code == "SCLN0195" || response.error.code == "SCLN0196"){
            if(response.error?.error) {
                this.errorMessage = response.error?.error;
            }
            else {
                this.errorMessage = COMMON_ERROR.DEFAULT;
            }
            return;
        }
         
        if (screen == 'OTP') {
            if (response == null || response == undefined) {
                this.errorMessage = COMMON_ERROR.DATA_BLANK;
            } else if (response.error.code == "SCLN0032" || response.error.code == "SCLN0110") {
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0110;
            } else if (response.error.code == "SCLN0111" || response.error.code == "SCLN0309" || response.error.code == "SCLN0316" || response.error.code == "SCLN0320" || response.error.code == "SCLN0321") {
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0111;
            } else if (response.error.code == "SCLN0301" || response.error.code == "SCLN0325") {
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0301;
            } else if (response.error.code == "SCLN0045") {
                this.errorMessage = COMMON_ERROR.SCLN0045;
            } else if (response.error.code == "TEJRF0500") {
                this.errorMessage = COMMON_ERROR.TEJRF0500;
            } else if (response.error.code == "SCLN0006" || response.error.code == "SCLN0312" || response.error.code == "SCLN0313") {
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0006;
            } else if(response.error.code == "SCLN0311"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0311;
            } else if(response.error.code == "TEJVF0002"){
                this.errorMessage = LOGIN_ERROR.IDAM_TEJVF0002;
            } else if(response.error.code == "SCLN0310"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0310;
            }else if(response.error.code == "SCLN0144"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0310;
            }else if(response.error.code == "SCLN0179"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0179;
            }else if(response.error.code == "SCLN0183"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0183;
            }else if(response.error.code == "SCLN0010"){
                this.errorMessage = LOGIN_ERROR.OTP_SCLN0010;
            }else if(response.error.code == "SCLN0401"){
                this.errorMessage = response.error?.error;
            }else {
                this.errorMessage = LOGIN_ERROR.genericError;
            }


        } else if (screen == 'QR') {
            if (response == null || response == undefined) {
                this.errorMessage = LOGIN_ERROR.UseOtherLoginOption
            } else if (response.error.code == "SCLN0058") {
                this.errorMessage = LOGIN_ERROR.SCLN0058;
            } else if (response.error.code == "SCLN0305") {
                this.errorMessage = LOGIN_ERROR.SCLN0305;
            } else if (response.error.code == "SCLN0018") {
                this.errorMessage = LOGIN_ERROR.SCLN0018;
            } else if (response.error.code == "SCLN0013") {
                this.errorMessage = LOGIN_ERROR.SCLN0013;
            } else if (response.error.code == "SCLN0306") {
                this.errorMessage = LOGIN_ERROR.SCLN0306;
            } else if (response.error.code == "SCLN0308") {
                this.errorMessage = LOGIN_ERROR.SCLN0308;
            } else {
                this.errorMessage = LOGIN_ERROR.UseOtherLoginOption
            }
        }else if(screen == "PASSPHRASE"){
            let invalidPassPhraseCounter
            if(localStorage.getItem('invalidPassPhraseCounter') != null){
                invalidPassPhraseCounter = JSON.parse(localStorage.getItem('invalidPassPhraseCounter'))
            }
            if(invalidPassPhraseCounter == 1){
                this.errorMessage = HTML_ERRORS["LOCK_APP_WARNING"];
            }else if (response == null || response == undefined) {
                this.errorMessage = LOGIN_ERROR.UseOtherLoginOption
            } else if (response.error.code == "SCLN0141" || response.error.code == "SCLN0140") {
                this.errorMessage = LOGIN_ERROR.Invalid_Passphrase;
            } else {
                this.errorMessage = LOGIN_ERROR.UseOtherLoginOption
            }
        }else if (screen == 'google' || screen == 'facebook' || screen == 'apple') {
            if (response == null || response == undefined) {
                this.errorMessage = LOGIN_ERROR.SOCIAL_ERROR;
            }
            this.errorMessage = this.errorMessage.replace('Social', screen);
        }
    }

    public blankCheck(screen: any, id: any, password: any) {
        if (screen == "OTP") {
            if (isNaN(password) == true) {
                this.errorMessage = LOGIN_ERROR.OTP_Enter_OTP_Check;
            } else if (!password || password.length != 6) {
                if(this.universalService.iCloudBackup){
                this.errorMessage = LOGIN_ERROR.ICLOUD_2FA_CODE_LENGTH;
                }else{
                this.errorMessage = LOGIN_ERROR.OTP_Invalid_OTP_Length;

                }
            }
        }

        return this.errorMessage;
    }
    
    public catchException(error: any) {
        super.catchException(error);
    }
}
